import { render } from "./TrfSimpleModal.vue?vue&type=template&id=3246d2c5&scoped=true"
import script from "./TrfSimpleModal.vue?vue&type=script&lang=js"
export * from "./TrfSimpleModal.vue?vue&type=script&lang=js"

import "./TrfSimpleModal.vue?vue&type=style&index=0&id=3246d2c5&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3246d2c5"],['__file',"src/components/Modal/TrfSimpleModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3246d2c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3246d2c5', __exports__)) {
    console.log('reload')
    api.reload('3246d2c5', __exports__)
  }
  
  module.hot.accept("./TrfSimpleModal.vue?vue&type=template&id=3246d2c5&scoped=true", () => {
    console.log('re-render')
    api.rerender('3246d2c5', render)
  })

}


export default __exports__